import React from "react";
import { dialog, Button, Progress, InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import AccomplishmentReportPresenter from "../AccomplishmentsTable/AccomplishmentReportPresenter";

class UserRecommendations extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AccomplishmentReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      newObj: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      await this.fetchData();
    }
  }

  async fetchData() {
    const user = this.getCurrentUser();
    const commendation = await findObjectUseCase().execute(
      "commendation_list",
      { where: { employeeID: user.employee.id } }
    );
    this.setState({ newObj: commendation, count: commendation.length });
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "commendation_list";
    // return "list_of_my_recommendation";
  }

  async refetchData() {
    return this.fetchData();
  }

  handleViewData(object) {
    // this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());

    const { count, current, limit } = this.state;

    if (!schema) return <Progress />;
    return (
      <>
        <div style={{ margin: "1rem 0" }}>
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>
        </div>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex justify-content-between">
                  <h4 className="text-primary">{schema.label}</h4>
                </div>
              </CardView>

              <Table
                // progress={count > this.state.newObj.length}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleViewData.bind(this)}
                fields={schema.fields}
                objects={this.state.newObj}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                // actionsList={[
                //   {
                //     label: <i className="bi bi-search"> View</i>,
                //     actionType: "object",
                //   },
                // ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "acl", "employeeID"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(UserRecommendations);
